module.exports = __webpack_public_path__ + "img/bola_mundo.c0bfb211.png";